// extracted by mini-css-extract-plugin
module.exports = {"root":"RemainsContainerBlock_root__1FPoN","wrapper":"RemainsContainerBlock_wrapper__23Nvp"};